import React, { useState, useEffect } from "react";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";

const CheckoutPage = () => {
  const { cartItems } = useCart();
  const navigate = useNavigate();
  const username = localStorage.getItem("username") || "";
  const [step, setStep] = useState(2);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    phone: "",
    pincode: "",
    locality: "",
    address: "",
    city: "",
    state: "",
    landmark: "",
  });

  // 🧮 Totals
  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );
  const discount = Math.floor(totalPrice * 0.25);
  const finalAmount = totalPrice - discount;

  // 📦 Load addresses
  useEffect(() => {
    const token =
      localStorage.getItem("access_token") ||
      localStorage.getItem("access") ||
      localStorage.getItem("jwt");

    setLoading(true);
    fetch("https://hrgf.salepatner.com/api/addresses/", {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    })
      .then((res) => res.json())
      .then((data) => setAddresses(data))
      .catch(() => setAddresses([]))
      .finally(() => setLoading(false));
  }, []);

  // 💾 Save address
  const handleAddAddress = async (e) => {
    e.preventDefault();

    if (!form.name || !form.phone || !form.address || !form.city || !form.state || !form.pincode) {
      alert("Please fill all required fields!");
      return;
    }

    try {
      const token =
        localStorage.getItem("access_token") ||
        localStorage.getItem("access") ||
        localStorage.getItem("jwt");

      const res = await fetch("https://hrgf.salepatner.com/api/addresses/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
        body: JSON.stringify(form),
      });

      if (!res.ok) {
        const err = await res.text();
        console.log("Error Response:", err);
        throw new Error("Error saving address");
      }

      const newAddr = await res.json();
      setAddresses([...addresses, newAddr]);
      setShowAddressForm(false);
      setForm({
        name: "",
        phone: "",
        pincode: "",
        locality: "",
        address: "",
        city: "",
        state: "",
        landmark: "",
      });
      alert("✅ Address saved successfully!");
    } catch (error) {
      console.error("❌ Error:", error);
      alert("❌ Error saving address");
    }
  };

  // 🚚 Select delivery address
  const handleDeliverHere = (addr) => {
    setSelectedAddress(addr);
    setStep(3);
  };

  // 💰 Continue to payment
  const handleContinueToPayment = () => {
    setStep(4);
  };

  // 🔥 Razorpay Payment
  const handlePayment = async () => {
    const token = localStorage.getItem("access_token");

    // ------------------------
    // FIX 1 — Prevent crash before backend
    // ------------------------
    if (!selectedAddress) {
      alert("Please select a delivery address first!");
      return;
    }

    if (cartItems.length === 0) {
      alert("Your cart is empty!");
      return;
    }

    // ------------------------
    // Create Order API
    // ------------------------
    const createOrder = await fetch("https://hrgf.salepatner.com/api/create-order/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        amount: finalAmount,
        product_id: cartItems[0]?.id,
        address_id: selectedAddress?.id,
        quantity: cartItems[0]?.quantity,
      }),
    });

    // ------------------------
    // FIX 2 — If order creation fails
    // ------------------------
    if (!createOrder.ok) {
      const err = await createOrder.text();
      console.log("Order create error:", err);
      alert("Order creation failed. Check address & cart.");
      return;
    }

    const data = await createOrder.json();

    const options = {
      key: data.key,
      amount: data.amount,
      currency: "INR",
      name: "Aerth.com",
      description: "Order Payment",
      order_id: data.order_id,

      handler: async function (response) {
        await fetch("https://hrgf.salepatner.com/api/verify-payment/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(response),
        });

        alert("🎉 Payment Successful!");
        navigate("/payment-success");
      },

      prefill: {
        name: username,
        email: "customer@example.com",
        contact: "9999999999",
      },
      theme: {
        color: "#FF6600",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };


  

  return (

    <>
    {/* ONLY LOGO NAVBAR */}
    <header className="sticky top-0 z-50 bg-white shadow-sm border-b border-gray-100">
      <div className="w-full flex items-center justify-between px-6 py-3">
        <div
          className="text-3xl font-extrabold tracking-tight flex items-center gap-1 cursor-pointer"
          onClick={() => navigate("/")}
        >
          <span className="text-orange-500">HRGF</span>
          <span className="text-blue-600">.com</span>
        </div>
      </div>
    </header>

    <div className="bg-[#f1f3f6] min-h-screen py-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-6">

        {/* LEFT SECTION */}
        <div className="lg:col-span-2 bg-white rounded-md shadow">

          {/* STEP 1: LOGIN */}
          <div className="border-b border-gray-200">
            <div className="flex justify-between items-center p-5 bg-blue-50 border-l-4 border-blue-600">
              <h3 className="font-semibold text-blue-800">1. LOGIN</h3>
            </div>

            <div className="px-5 pb-5">
              {localStorage.getItem("username") ? (
                <div className="flex justify-between items-center">
                  <div className="text-gray-800 text-sm">
                    Hello, <b>{localStorage.getItem("username")}</b> 👋 <br />
                    <span className="text-gray-500">You’re securely logged in.</span>
                  </div>
                  <button
                    onClick={() => {
                      localStorage.removeItem("username");
                      localStorage.removeItem("access_token");
                      window.location.reload();
                    }}
                    className="text-blue-600 font-semibold text-sm hover:underline"
                  >
                    LOGOUT
                  </button>
                </div>
              ) : (
                <div className="flex flex-col sm:flex-row sm:justify-between items-start sm:items-center gap-3">
                  <div className="text-gray-700 text-sm">
                    To place your order, please log in with your account.
                  </div>
                  <button
                    onClick={() =>
                      navigate("/login", { state: { from: "/checkout" } })
                    }
                    className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-md font-semibold"
                  >
                    LOGIN TO CONTINUE
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* STEP 2: DELIVERY ADDRESS */}
          <div className="border-b border-gray-200">
            <div className="flex justify-between items-center p-5 bg-blue-50 border-l-4 border-blue-600">
              <h3 className="font-semibold text-blue-800">2. DELIVERY ADDRESS</h3>
            </div>

            {loading ? (
              <p className="p-5 text-gray-500">Loading addresses...</p>
            ) : !showAddressForm ? (
              <div className="p-5 space-y-4">
                {addresses.length > 0 ? (
                  addresses.map((addr) => (
                    <div
                      key={addr.id}
                      className={`border rounded-md p-4 flex justify-between items-start ${
                        selectedAddress?.id === addr.id
                          ? "border-blue-600"
                          : "border-gray-200"
                      }`}
                    >
                      <div>
                        <h4 className="font-semibold text-gray-800">
                          {addr.name}{" "}
                          <span className="text-sm text-gray-500">
                            {addr.phone}
                          </span>
                        </h4>
                        <p className="text-sm text-gray-700 mt-1">
                          {addr.address}, {addr.city}, {addr.state} -{" "}
                          <b>{addr.pincode}</b>
                        </p>
                      </div>
                      <button
                        onClick={() => handleDeliverHere(addr)}
                        className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 py-2 rounded-md"
                      >
                        DELIVER HERE
                      </button>
                    </div>
                  ))
                ) : (
                  <p className="text-gray-600 text-sm italic">
                    No saved addresses found.
                  </p>
                )}

                <button
                  onClick={() => setShowAddressForm(true)}
                  className="text-blue-600 text-sm font-semibold mt-2 hover:underline"
                >
                  + Add a new address
                </button>
              </div>
            ) : (
              <form onSubmit={handleAddAddress} className="p-6 bg-blue-50 space-y-4">
                <h4 className="font-semibold text-gray-800">ADD A NEW ADDRESS</h4>

                <div className="grid grid-cols-2 gap-4">
                  <input
                    type="text"
                    placeholder="Full Name"
                    className="border rounded p-2 text-sm"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    required
                  />
                  <input
                    type="text"
                    placeholder="10-digit mobile number"
                    className="border rounded p-2 text-sm"
                    value={form.phone}
                    onChange={(e) => setForm({ ...form, phone: e.target.value })}
                    required
                  />
                  <input
                    type="text"
                    placeholder="Pincode"
                    className="border rounded p-2 text-sm"
                    value={form.pincode}
                    onChange={(e) => setForm({ ...form, pincode: e.target.value })}
                    required
                  />
                  <input
                    type="text"
                    placeholder="Locality"
                    className="border rounded p-2 text-sm"
                    value={form.locality}
                    onChange={(e) =>
                      setForm({ ...form, locality: e.target.value })
                    }
                  />
                </div>

                <textarea
                  placeholder="Address (Area and Street)"
                  className="border rounded p-2 w-full text-sm"
                  rows="2"
                  value={form.address}
                  onChange={(e) =>
                    setForm({ ...form, address: e.target.value })
                  }
                  required
                />

                <div className="grid grid-cols-2 gap-4">
                  <input
                    type="text"
                    placeholder="City/District/Town"
                    className="border rounded p-2 text-sm"
                    value={form.city}
                    onChange={(e) =>
                      setForm({ ...form, city: e.target.value })
                    }
                    required
                  />
                  <input
                    type="text"
                    placeholder="State"
                    className="border rounded p-2 text-sm"
                    value={form.state}
                    onChange={(e) =>
                      setForm({ ...form, state: e.target.value })
                    }
                    required
                  />
                </div>

                <input
                  type="text"
                  placeholder="Landmark (Optional)"
                  className="border rounded p-2 text-sm w-full"
                  value={form.landmark}
                  onChange={(e) =>
                    setForm({ ...form, landmark: e.target.value })
                  }
                />

                <div className="flex items-center space-x-4 mt-2">
                  <button
                    type="submit"
                    className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-md font-semibold"
                  >
                    SAVE AND DELIVER HERE
                  </button>
                  <button
                    type="button"
                    onClick={() => setShowAddressForm(false)}
                    className="text-blue-600 font-semibold"
                  >
                    CANCEL
                  </button>
                </div>
              </form>
            )}
          </div>

          {/* STEP 3: ORDER SUMMARY */}
          {step === 3 && (
            <div className="border-b border-gray-200">
              <div className="flex justify-between items-center p-5 bg-gray-50">
                <h3 className="font-semibold text-gray-800">3. ORDER SUMMARY</h3>
              </div>

              <div className="p-5 space-y-3">
                {cartItems.map((item) => (
                  <div
                    key={item.id}
                    className="flex justify-between items-center border-b py-2"
                  >
                    <div className="flex items-center gap-3">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-16 h-16 object-cover rounded"
                      />
                      <div>
                        <p className="font-medium text-gray-800">{item.title}</p>
                        <p className="text-sm text-gray-500">
                          Qty: {item.quantity}
                        </p>
                      </div>
                    </div>
                    <p className="font-semibold text-gray-900">
                      ₹{item.price}
                    </p>
                  </div>
                ))}

                <div className="flex justify-end mt-4">
                  <button
                    onClick={handlePayment}
                    className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-md font-semibold"
                  >
                    CONTINUE TO PAYMENT
                  </button>
                </div>
              </div>
            </div>
          )}

        </div>

        {/* RIGHT SECTION */}
        <div className="relative">
          <div className="sticky top-6 bg-white rounded-md shadow p-5">
            <h3 className="font-semibold text-gray-700 border-b pb-2 mb-4">
              PRICE DETAILS
            </h3>
            <div className="text-sm text-gray-700 space-y-2">
              <div className="flex justify-between">
                <p>Price ({cartItems.length} items)</p>
                <p>₹{totalPrice.toLocaleString()}</p>
              </div>
              <div className="flex justify-between">
                <p>Discount</p>
                <p className="text-green-600">
                  − ₹{discount.toLocaleString()}
                </p>
              </div>
              <hr className="my-2 border-dashed border-gray-300" />
              <div className="flex justify-between font-semibold text-gray-800">
                <p>Total Payable</p>
                <p>₹{finalAmount.toLocaleString()}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>


   <footer className="bg-[#f1f3f6] border-t border-gray-300 py-6 !m-0">
  <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center text-sm text-gray-700 mb-18">


    {/* Left Side Links */}
    <div className="flex flex-wrap items-center gap-3 md:gap-5">
      <span className="font-semibold">Policies:</span>

      <a href="#" className="hover:underline">Returns Policy</a>
      <span className="text-gray-400">|</span>

      <a href="#" className="hover:underline">Terms of use</a>
      <span className="text-gray-400">|</span>

      <a href="#" className="hover:underline">Security</a>
      <span className="text-gray-400">|</span>

      <a href="#" className="hover:underline">Privacy</a>

      <span className="ml-3 text-gray-500">
        © {new Date().getFullYear()} HRGF.com
      </span>
    </div>

    {/* Right Side Help Links */}
    <div className="mt-4 md:mt-0 text-sm">
      Need help? Visit the{" "}
      <a href="#" className="text-blue-600 font-medium hover:underline">Help Center</a>{" "}
      or{" "}
      <a href="#" className="text-blue-600 font-medium hover:underline">Contact Us</a>
    </div>

  </div>
</footer>
    </>
  );
};

export default CheckoutPage;
